import React from "react";

const EventLocationIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <g clipPath="url(#clip0_3998_61733)">
      <path d="M0.664062 4.00065V14.6673L5.33073 12.0007L10.6641 14.6673L15.3307 12.0007V1.33398L10.6641 4.00065L5.33073 1.33398L0.664062 4.00065Z" stroke="#707070" strokeWidth="1.33158" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5.32812 1.33398V12.0007" stroke="#707070" strokeWidth="1.33158" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10.6719 4V14.6667" stroke="#707070" strokeWidth="1.33158" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_3998_61733">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

export default EventLocationIcon;   